(() => {
  'use strict';

  function hydrate(root = document) {
    const productRoots = [];
    if (root && root.matches && root.matches('[data-sdp-product]')) productRoots.push(root);
    if (root && root.querySelectorAll) productRoots.push(...root.querySelectorAll('[data-sdp-product]'));

    productRoots.forEach((productRoot) => {
      const master = productRoot.querySelector('select[name="id"]');
      const json = productRoot.querySelector('script[id^="ProductJson-"][type="application/json"]');
      if (!master || !json || json.dataset.sdAvailabilityHydrated === 'true') return;

      try {
        const product = JSON.parse(json.textContent || '{}');
        if (!product || !Array.isArray(product.variants)) return;

        const availability = new Map();
        Array.from(master.options || []).forEach((option) => {
          availability.set(String(option.value), !option.disabled);
        });

        product.variants.forEach((variant) => {
          const id = String(variant.id);
          if (availability.has(id)) variant.available = availability.get(id);
        });

        json.textContent = JSON.stringify(product);
        json.dataset.sdAvailabilityHydrated = 'true';
      } catch (error) {
        console.warn('[ShadowsDeal] Availability bridge skipped:', error);
      }
    });
  }

  hydrate(document);
  document.addEventListener('shopify:section:load', (event) => hydrate(event.target || document));
})();
